module.exports = __webpack_public_path__ + "img/button_Play.336c56f8.svg";